export default "__VITE_ASSET__CHr2Ntcn__ 480w, __VITE_ASSET__BKzNOhso__ 768w, __VITE_ASSET__DO74iNDi__ 960w";